import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask900To999Service {

  constructor() { }
}
